import axios from "axios";

import { CANCEL } from "redux-saga";
import _ from "lodash";
import { wrapURLs } from "../helpers";

// Import store to get access to state data - we'll use this to decide whether to fetch new POI data from the API
import store from "../store";

const API_ROOTS = {
	opendata: "https://opendata.bristol.gov.uk/api/records/1.0/search/?dataset=",
    bristol: "https://maps2.bristol.gov.uk/server2/rest/services/ext/"
}

const CancelToken = axios.CancelToken;
let source;

function callGIS(query, service = 'opendata') {
	return new Promise((resolve, reject) => {
		// Run query or return empty
		if (query) {
            query = API_ROOTS[service] + query;

			axios
				.get(query)
				.then((response) => {
					// Check returned data
					if (response.data) {
						resolve(response.data);
					} else {
						reject("no posts");
					}
				})
				.catch((error) => {
					reject(error);
				});
		} else {
			resolve(null);
		}
	});
}

export const getPOI = (options) => {
	const { POIType } = options;
	let query;
    let service = 'opendata';

	switch (POIType) {
		case "bikePumps":
			query = "datagov/MapServer/201/query?outFields=*&where=1%3D1&f=geojson";
            service = 'bristol';
			break;
		case "cycleShopsAndRepairs":
			query = "datagov/MapServer/14/query?outFields=*&where=1%3D1&f=geojson";
            service = 'bristol';
			break;
		case "bmxFacilities":
			query = "datagov/MapServer/203/query?outFields=*&where=1%3D1&f=geojson";
            service = 'bristol';
			break;
		default:
			query = null;
	}

	return new Promise((resolve, reject) => {
		// Check whether state already has POI data for this POI type before calling the API
		const currentState = store.getState();
		const poiData = currentState.POI.poi;

		// If data already in state, resolve the promise with it
		if (poiData[POIType] && poiData[POIType].results) {
			const markers = poiData[POIType].results.markers;

			resolve({ markers });

			// Else, fetch the data from the API
		} else {
			callGIS(query, service).then((response) => {
                // opendata returns records, bristol returns features
                const records = response.records || response.features

				let markers = records
					.map((single) => {
						let marker;

						switch (POIType) {
							case "bikePumps": {
								const location = {
									lat: single.geometry.coordinates[1],
									lng: single.geometry.coordinates[0],
								};

								const title = single.properties.NAME;
								const maintained = single.properties.MAINTAINED;
								const type = single.properties.TYPE;
								const image = single.properties.PHOTO
									? single.properties.PHOTO.replace("wp-content", "app")
									: "";

								let content = maintained
									? `<h4 class="infowindow-title">${ title }</h4>`
									: "";

								content += maintained
									? `<p class="infowindow-contact">${ wrapURLs(
										maintained,
										true
									) }</p>`
									: "";

								content += type
									? `<p class="infowindow-type">Type: ${ type }</p>`
									: "";

								const imgContent = image
									? `<img src=${ image } alt="Image of bike pump area"/>`
									: "";

								// Add image.
								if (image) {
									content = imgContent + content;
								}

								const icon = {
									url: `${ window.ROOT }${ window.PORT }/images/markers/pump.svg`,
									size: { width: 35, height: 45 },
									scaledSize: { width: 35, height: 45 },
									anchor: { x: 18, y: 45 },
								};

								marker = {
									location,
									title,
									content,
									icon,
									type,
								};

								break;
							}

							case "cycleShopsAndRepairs": {
								const location = {
									lat: single.geometry.coordinates[1],
									lng: single.geometry.coordinates[0],
								};
								const title = single.properties.NAME;
								const link = single.properties.WEBSITE;
								const description = single.properties.DESCRIPTION;
								const website = single.properties.WEBSITE;

								let address = single.properties.ADDRESS;
								address = address && address.replace(/,/g, ",<br/>");
								const phone = single.properties.PHONE;

								const services_provided = single.properties.SERVICES_PROVIDED;

								const content =
									`<h4 class="infowindow-title">${ title || "BMX Facilities"
									}</h4>
								<p class="infowindow-desc">${ description }</p>
								<p class="infowindow-services"><span>Services Offered</span> <br/>${ services_provided }</p>
								<p class="infowindow-website"><a href="${ website }" target="_blank">${ website } (Opens in new window)</a></p>
								<p class="infowindow-address"><span>Address</span><br/>${ address }</p>
								<p class="infowindow-phone"><span>Phone</span><br/>${ phone }</p>` +
									(link
										? `<a href=${ link } target="_blank">${ link } (Opens in new window)</a>`
										: ``);

								const icon = {
									url: `${ window.ROOT }${ window.PORT }/images/markers/shop.svg`,
									size: { width: 35, height: 45 },
									scaledSize: { width: 35, height: 45 },
									anchor: { x: 18, y: 45 },
								};

								marker = {
									location,
									title,
									content,
									icon,
								};

								break;
							}

							case "bmxFacilities": {
								const location = {
									lat: single.geometry.coordinates[1],
									lng: single.geometry.coordinates[0],
								};
								const title = single.properties.NAME;
								let address = single.properties.ADDRESS;
								address = address && address.replace(/,/g, ",<br/>");
								const description = single.properties.DESCRIPTION;

								const image = single.properties.PHOTO
									? single.properties.PHOTO.replace("wp-content", "app")
									: "";

								let content = `
								<h4 className="infowindow-title">${ title || "BMX Facilities" }</h4>
								<p className="infowindow-desc">${ description }</p>
								<p className="infowindow-address"><span>Address</span><br/>${ address }</p>
							`;

								const imgContent = `<img src=${ image } alt="Image of BMX Facility"/>`;

								// Add image.
								if (image) {
									content = imgContent + content;
								}

								const icon = {
									url: `${ window.ROOT }${ window.PORT }/images/markers/bmx.svg`,
									size: { width: 35, height: 45 },
									scaledSize: { width: 35, height: 45 },
									anchor: { x: 18, y: 45 },
								};

								marker = {
									location,
									title,
									content,
									icon,
								};

								break;
							}

							default:
								marker = null;
						}

						return marker;
					})
					.filter((marker) => marker !== null);

				resolve({ markers });
			});
		}
	});
};

export const getRides = () => {
	let query = "datagov/MapServer/202/query?outFields=*&where=1%3D1&f=geojson";
    let service = 'bristol';

	return new Promise((resolve, reject) => {
		callGIS(query, service).then((response) => {
			/* Certain attributes we need a single value for, like difficulty and type, are sometimes
			entered in to the API as a multi-value string like "1, 2". Here we process the rides and
			change those strings to a single value, like "1", and add more user friendly text
			interpretations of them to each ride's data */
			const leisureRides = response.features;

			const allRides = leisureRides.map((ride, i) => {
				const paths = ride.geometry.coordinates;

				const difficulty = ride.properties.DIFFICULTY
					.replace(" ", "")
					.split(",")[0];
				const type = ride.properties.ROUTE_TYPE.replace(" ", "").split(",")[0];

				// Add text strings for difficulty and type
				let difficultyText;
				switch (difficulty) {
					case "1":
						difficultyText = "Easy";
						break;

					case "2":
						difficultyText = "Moderate";
						break;

					case "3":
						difficultyText = "Challenging";
						break;

					default:
						difficultyText = "Unknown";
				}

				let typeText;
				switch (type) {
					case "1":
						typeText = "Leisure ride";
						break;

					case "2":
						typeText = "Commuter route";
						break;

					case "3":
						typeText = "Mountain bike trail";
						break;

					default:
						typeText = "Unknown";
				}

				return {
					color: ride.properties.COLOUR_CODE || "2A6C93",
					difficulty,
					difficultyText,
					type,
					typeText,
					description: ride.properties.DESCRIPTION,
					distance: ride.properties.DISTANCE,
					image: ride.properties.PHOTO
						? ride.properties.PHOTO.replace("wp-content", "app")
						: "",
					max_time: ride.properties.MAX_TIME,
					min_time: ride.properties.MIN_TIME,
					name: ride.properties.ROUTE_NAME,
					url: ride.properties.URL,
					video: ride.properties.video,
					pdf: ride.properties.FEATURED_IN
						? ride.properties.FEATURED_IN.replace("wp-content", "app")
						: "",
					kml: ride.properties.KML
						? ride.properties.KML.replace("wp-content", "app")
						: "",
					gpx: ride.properties.GPX
						? ride.properties.GPX.replace("wp-content", "app")
						: "",
					kml_file_size: ride.properties.KML_FILE_SIZE,
					gpx_file_size: ride.properties.GPX_FILE_SIZE,
					paths:
						paths[0].length === 2
							? [ride.geometry.coordinates]
							: ride.geometry.coordinates,
				};
			});

			// Add amended API data to application state along with a gotData boolean
			const result = {
				...allRides,
				gotData: true,
			};

			resolve(result);
		});
	});
};

export const getLCN = () => {
	let query =
		"datagov/FeatureServer/3/query?outFields=*&where=1%3D1&f=geojson";
    let service = 'bristol';

	return new Promise((resolve, reject) => {
		callGIS(query, service).then((response) => {
			const LCN = response.features;

			/* API might return cycle routes with no coordindates, so we'll filter those out and
			base our work on a new array of routes that we know have complete data - filteredRoutes */
			let filteredRoutes = [];

			LCN.forEach((route) => {
				if (route.geometry && route.geometry.coordinates) {
					filteredRoutes.push(route);
				}
			});

			const allRoutes = filteredRoutes.map((route) => {
				const { properties, geometry } = route;

				// Get coordinates of points to plot for each route
				const paths = geometry.coordinates;

				/* NB: each path should be an array of lng/lat. In some cases though, there are nested arrays.
				Here we flatten those nested arrays returned by the API and add them to a new array of sanitised data. */
				let flattenedPaths = [];

				paths.forEach((path, i) => {
					// Flatten nested arrays if present
					if (Array.isArray(path[i])) {
						path = _.flattenDeep(path);
					}

					// Add the path to our set of sanitised data
					flattenedPaths.push(path);
				});

				return {
					color: properties.COLOUR_CODE || "2A6C93",
					name: properties.ROUTE_NAME,
					url: properties.URL || window.WEBSITE_ROOT,
					paths:
						flattenedPaths[0].length === 2
							? [geometry.coordinates]
							: geometry.coordinates,
					vehicles_estimate: properties.VEH_EST,
					quality: properties.QUALITY,
					description: "This is a description of the route",
				};
			});

			// Add amended API data to application state along with a gotData boolean
			const result = {
				...allRoutes,
				gotData: true,
			};

			resolve(result);
		});
	});
};

const regionsMap = {
	bristol: "Bristol",
	"south gloucestershire": "South Gloucestershire",
	"bath & ne somerset": "Bath and North East Somerset",
	"bath and north east somerset": "Bath and North East Somerset",
	"north somerset": "North Somerset",
};

export const getSR = (sr) => {
	let { regions } = sr;

	const regionsInResponse = regions.map(
		(region) => regionsMap[region.toLowerCase()]
	);

	return new Promise((resolve) => {
        const query = 'cycle_woe_network/MapServer/0/query?outFields=*&where=1%3D1&f=geojson';
        const service = 'bristol';
		callGIS(query, service).then((response) => {
            const SR = response.features;

			// Check Coords and that the route belongs to the selected regions
			const filteredRoutes = SR.filter(({ properties, geometry }) => {
				const { REGION: region } = properties;

				const routeRegions = region ? region.split(",") : [];

				const match = routeRegions.reduce((match, routeRegion) => {
					if (match) {
						return match;
					}
					return regionsInResponse.find((region) => region === routeRegion);
				}, false);

				return match && geometry && geometry.coordinates;
			});

			const allRoutes = filteredRoutes.map(({ properties, geometry }) => {
				// Get coordinates of points to plot for each route
				const paths = geometry.coordinates;
                const props = Object.entries(properties).reduce((obj, [key, value]) => ({
                    ...obj,
                    [key.toLowerCase()]: value
                }), {});

				/* NB: each path should be an array of lng/lat. In some cases though, there are nested arrays.
				Here we flatten those nested arrays returned by the API and add them to a new array of sanitised data. */
				const flattenedPaths = paths.map((path, i) => {
					// Flatten nested arrays if present
					if (Array.isArray(path[i])) {
						path = _.flattenDeep(path);
					}

					// Add the path to our set of sanitised data
					return path;
				});
				return {
					...props,
					color: props.colour || "2A6C93",
					paths: flattenedPaths[0].length === 2 ? [paths] : paths,
					name: props.route,
					image: props.image ? props.image.replace("wp-content", "app") : "",
					kml: props.kml ? props.kml.replace("wp-content", "app") : null,
					kml_file_size: props.kml_file_size,
					gpx_file_size: props.gpx_file_size,
					// for some reason the GPX file name comes back
					// from the API with underscores and not hyphens
					// so these need to be replaced
					gpx: props.gpx
						? props.gpx.replace("wp-content", "app").replace(/_/g, "-")
						: null,
				};
			});

			allRoutes.sort(function(a, b) {
				if (a.name < b.name) return -1;
				if (a.name > b.name) return 1;
				return 0;
			});

			// Add amended API data to application state along with a gotData boolean
			const result = {
				...allRoutes,
				gotData: true,
			};

			resolve(result);
		});
	});
};

// TODO: this isn't called anywhere in the app - can it be removed?
export const getSUS = () => {
	// Note excluding local isn't getting rid of concorde which is regional.. but this will take avon ring road with it.
	let query = "boundaries/MapServer/11/query?outFields=*&where=1%3D1&f=geojson";
    let service = "bristol";

	return new Promise((resolve, reject) => {
		callGIS(query, service).then((response) => {
			const SUS = response.features;
			/* API might return cycle routes with no coordindates, so we'll filter those out and
			base our work on a new array of routes that we know have complete data - filteredRoutes */
			let filteredRoutes = [];

			SUS.forEach((route) => {
				if (route.geometry && route.geometry.coordinates) {
					filteredRoutes.push(route);
				}
			});

			const allRoutes = filteredRoutes.map((route) => {
				// Get coordinates of points to plot for each route
				const paths = route.geometry.coordinates;

				/* NB: each path should be an array of lng/lat. In some cases though, there are nested arrays.
				Here we flatten those nested arrays returned by the API and add them to a new array of sanitised data. */
				let flattenedPaths = [];

				paths.forEach((path, i) => {
					// Flatten nested arrays if present
					if (Array.isArray(path[i])) {
						path = _.flattenDeep(path);
					}

					// Add the path to our set of sanitised data
					flattenedPaths.push(path);
				});

				return {
					color: route.properties.COLOUR_CODE || "2A6C93",
					name: route.properties.NAME,
					url: route.properties.URL || window.WEBSITE_ROOT,
					paths:
						flattenedPaths[0].length === 2
							? [route.geometry.coordinates]
							: route.geometry.coordinates,
					onRoad: route.properties.ON_ROAD,
					trafficFree:
						route.properties.ON_ROAD === "Traffic free route" ? true : false,
					description: route.properties.DESCRIPTION,
					routeNo: route.properties.IDENTIFIER,
				};
			});

			// Add amended API data to application state along with a gotData boolean
			const result = {
				...allRoutes,
				gotData: true,
			};

			resolve(result);
		});
	});
};

export const getCycleHireOD = (options) => {
    getSUS()
	const { hireComp } = options;
	const query = "cycle_hire/MapServer/0/query?outFields=*&where=1%3D1&f=geojson";
    const service = "bristol";

	// Cycle hire just for stationary. The others can be found in rm.js.
	const promise = new Promise((resolve, reject) => {
		source = CancelToken.source();

		// Check whether state already has rental data for this rental type before calling the API
		const currentState = store.getState();

		// If data already in state, resolve the promise with it
		if (
			currentState.cycleHire.hireCompany &&
			currentState.cycleHire.hireCompany[hireComp]
		) {
			const markers =
				currentState.cycleHire.hireCompany[hireComp].results.markers;

			resolve({ markers });

			// Else, fetch the data from the API
		} else {
			callGIS(query, service)
				.then((response) => {
					let marker;

					let markers = response.features
						.map((single) => {
							const icon_path = "map_end.png";

							const location = {
								lat: single.geometry.coordinates[1],
								lng: single.geometry.coordinates[0],
							};

							const { NAME, DESCRIPTIO, WEBSITE, PHONE, ADDRESS } = single.properties;

							const address = ADDRESS && ADDRESS.replace(/,/g, ",<br/>");

							const title = NAME;

							const content = `
						<h4 className="infowindow-title">${ NAME }</h4>
						<p className="infowindow-desc">${ DESCRIPTIO }</p>
						<p className="infowindow-website"><a href="${ WEBSITE }" target="_blank">${ WEBSITE } (Opens in new window)</a></p>
						<p className="infowindow-address"><span>Address</span><br/>${ address }</p>
						<p className="infowindow-phone"><span>Phone</span><br/>${ PHONE }</p>
					`;
							const scale = 0.6;
							const icon_size = { width: 44, height: 56 };
							const icon_scaled_size = {
								width: icon_size.width * scale,
								height: icon_size.height * scale,
							};
							const icon_anchor = {
								x: icon_scaled_size.width / 2,
								y: icon_scaled_size.height,
							};
							const icon = {
								url: `${ window.ROOT }${ window.PORT }/images/markers/${ icon_path }`,
								size: icon_size,
								scaledSize: icon_scaled_size,
								anchor: icon_anchor,
							};

							marker = {
								location,
								title,
								content,
								icon,
							};

							return marker;
						})
						.filter((marker) => marker !== null);

					resolve({ markers });
				})
				.catch((error) => {
					reject("Could not get rental.");
				});
		}
	});

	promise[CANCEL] = () => {
		source.cancel("Operation cancelled by the user.");
	};

	return promise;
};



// WEBPACK FOOTER //
// ./src/services/opendata.js